import RatingNum from './RatingNum'

export default RatingNum
